import {
  API_TYPES,
  type GetWorkerRequirementsResponse,
  type WorkerRequirementDomain,
} from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { type UseGetQueryOptions } from "@src/appV2/api";
import { type AxiosError } from "axios";

import { mergeWorkerRequirementWithIncludedResources } from "../mergeWorkerRequirementWithIncludedResources";
import { type WorkerRequirement } from "../types";
import { requirementRelationship, useGetWorkerRequirements } from "../useGetWorkerRequirements";

interface UseGetBlockingRequirementsForWorkplacesProps {
  workplaceIds: string[];
  qualifications: string[];
  domain?: WorkerRequirementDomain;
  visibleToWorker?: boolean;
}

export function useGetRequirementsForWorkplaces(
  props: UseGetBlockingRequirementsForWorkplacesProps,
  options: UseGetQueryOptions<GetWorkerRequirementsResponse, AxiosError, WorkerRequirement[]> = {}
) {
  const { workplaceIds, qualifications, domain, visibleToWorker } = props;

  return useGetWorkerRequirements(
    {
      filter: {
        workplaceIds,
        qualifications,
        requiredForBooking: true,
        ...(isDefined(domain) ? { domains: [domain] } : {}),
        ...(isDefined(visibleToWorker) ? { visibleToWorker } : {}),
      },
      include: [...requirementRelationship, API_TYPES.requirementMappings],
    },
    {
      select: mergeWorkerRequirementWithIncludedResources,
      ...options,
      enabled: workplaceIds.length > 0 && (options.enabled ?? true),
    }
  );
}
